export default __webpack_public_path__ + "static/media/login_dot_gov_logo_sign_in.1bcfccf0.svg";